module.exports = __webpack_public_path__ + "0a70596af6bd99481a429e8e0ea8b04b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_08_mobile.jpg
// module id = 659
// module chunks = 0